import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import moment from 'moment'
import { translation } from '../../../../utils/helpers'
import { renderFullDate, getRelativeDateTime } from '../../../../utils/time'
import { formatCurrency } from '../../../../utils/currency'

// Elements
import Text from '../../../elements/text'
import BottomBar from '../../../elements/bottomBar'
import CountSpecifier from '../../../elements/countSpecifier'
import SlidePanel from '../../../elements/slidePanel'
import Divider from '../../../elements/divider'
import OrangeDivider from '../../../elements/orangeDivider'
import Radio from '../../../elements/radio'
import Check from '../../../elements/check'
import Textarea from '../../../elements/textarea'
import LabelWrapper from '../../../elements/labelWrapper'
import { SparePartModuleIcons, ElementIcons } from '../../../elements/icons'
import Inline from '../../../elements/inline'
import Icon from '../../../elements/icon'
import DateTime from '../../../elements/datetime'
import Time from '../../../elements/time'
import RemoveButton from '../../../elements/removeButton'
import Label from '../../../elements/label'
import Grid from '../../../elements/grid'

import Dropzone from '../../../components/Dropzone'
import Gallery from '../../../components/Gallery'
import Portal from '../../../components/Portal'
import Confirm from '../../../components/Confirm'

// Actions
import { createSparePart, updateSparePartsOrdering, getOrderingSparePartSuppliers, getOrderingSparePartDetails } from '../../../../actions/spareparts'
import { uploadMultipleFiles, getOrderFiles } from '../../../../actions/orders'
import { closeSlidePanel, isSlidePanelOpen } from '../../../../actions/common'
import { getOrderFileSizes } from '../../../../actions/orderfiles'

// Constants
import {
  // API_BASE,
  FILE_STORAGE
} from '../../../../constants'

import './orderingslidepanel.scss'

class OrderingSlidePanel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedSpareParts: [],
      view: '',
      isOpen: false,
      isLoading: false,
      spareParts: [],
      SelectedFilesIds: [],
      SelectedFileSizes: {
        FileSizesInByte: {},
        TotalSizeInByte: 0,
        TotalSizeInKB: 0,
        TotalSizeInMB: 0,
        MaxEmailFileSizeInByte: 0,
        MaxEmailFileSizeInKB: 0,
        MaxEmailFileSizeInMB: 0,
        HasExeededMaxEmailFileSize: false
      },
      suppliers: [],
      add: {
        sparepart: {
          OrderId: 0,
          SparePartNumber: '',
          Quantity: 1
        }
      },
      statusChange: {
        Quantity: 1,
        Status: 1,
        QualityType: 0,
        SubQualityType: null,
        Comment: '',
        SupplierId: null,
        Pickup: null,
        Discount: null,
        DeliveryDate: null,
        AddCommentToOrderEmail: true
      },
      partNumberChange: {
        Quantity: 1,
        SparePartNumberAlias: '',
        useAlternativePartNumber: 0
      },
      supplierDeliveryChange: {
        supplierId: 0,
        deliveryDate: '',
        deliveryTime: ''
      },

      images: [],
      upload: {
        shouldCapture: true,
        errors: []
      },
      activeImage: {},
      imageUploadsStarted: 0,
      imageUploadsCompleted: 0,
      confirm: false,
      imageToDeleteId: 0
    }

    this.getOrderFileSizes = this.getOrderFileSizes.bind(this)
    this.getSpareParts = this.getSpareParts.bind(this)
    this.renderAddSparepart = this.renderAddSparepart.bind(this)
    this.renderStatusChange = this.renderStatusChange.bind(this)
    this.renderListDetail = this.renderListDetail.bind(this)
    this.renderSparepartNumberChange = this.renderSparepartNumberChange.bind(this)
    this.closeSlidePanel = this.closeSlidePanel.bind(this)
    this.changeView = this.changeView.bind(this)
    this.isDracarMatch = this.isDracarMatch.bind(this)
    this.usesDracar = this.usesDracar.bind(this)
    this.usesDracarCreation = this.usesDracarCreation.bind(this)
        // Image
    // this.submitImage = this.submitImage.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.onDropAccepted = this.onDropAccepted.bind(this)
    this.onDropRejected = this.onDropRejected.bind(this)
    this.checkboxChange = this.checkboxChange.bind(this)
    this.renderFileSizeError = this.renderFileSizeError.bind(this)
  }

  componentWillUnmount () {

  }

  componentDidMount () {
    let images = []
    this.props.getOrderFiles(this.props.orderId, 1).then((res) => {
      res.data.forEach(function (element) {
        images.push({
          imagePath: FILE_STORAGE + element.FileURL,
          thumbPath: FILE_STORAGE + element.ThumbURL,
          OrderFileID: element.OrderFileID
        })
      }, this)
      this.setState({
        images: images
      })
    })

    this.setState({
      view: this.props.view,
      spareParts: this.props.selectedSpareParts
    })

    this.getOrderFileSizes()
  }

  componentWillReceiveProps (next) {
    let selectedSpareParts = next.selectedSpareParts
    if (next.view === 'listDetail' && !isEqual(this.props.spareparts, next.selectedSpareParts) && next.selectedSpareParts.length === 1) {
      this.props.getOrderingSparePartDetails(next.selectedSpareParts[0]).then(res => {
        this.setState({
          spareParts: res.data,
          selectedSpareParts: selectedSpareParts
        }, () => {
          if (next.view !== this.state.view) {
            this.changeView(next.view)
          }
        })
      })
    } else if (!isEqual(this.state.spareparts, next.selectedSpareParts)) {
      let extra = {}
      let multiViewTotal = next.selectedSpareParts.reduce((total, part) => {
        return total + (part.Count - part.Handled)
      }, 0)
      let totalCount = next.selectedSpareParts.reduce((total, part) => {
        return total + part.Count
      }, 0)
      let selectedQualityType = this.state.statusChange.QualityType
      let selectedSubQualityType = this.state.statusChange.QualityType
      let status = this.state.statusChange.Status

      if (next.selectedSpareParts.length > 0) {
        selectedQualityType = next.selectedSpareParts[0].QualityType
        selectedSubQualityType = next.selectedSpareParts[0].SubQualityType
        status = next.selectedSpareParts[0].Status
        if (!next.selectedSpareParts.every(x => x.QualityType === selectedQualityType)) selectedQualityType = 0
        if (!next.selectedSpareParts.every(x => x.SubQualityType === selectedSubQualityType)) selectedSubQualityType = null
      }
      if (next.view === 'status') {
        // multi qualityType selection, is separate view
        if (next.selectedSpareParts.length > 1) {
          selectedQualityType = null
          selectedSubQualityType = null
          // in multi row selection, take only spare parts with unknown status
          totalCount = multiViewTotal
          status = 1
        }
        extra.statusChange = {
          ...this.state.statusChange,
          Quantity: totalCount,
          Status: status,
          QualityType: selectedQualityType,
          SubQualityType: selectedSubQualityType
        }
      } else if (next.view === 'partNumber') {
        extra.partNumberChange = {
          ...this.state.partNumberChange,
          Quantity: totalCount
        }
      } else if (next.view === 'multiQuality') {
        extra.statusChange = {
          ...this.state.statusChange,
          Quantity: multiViewTotal,
          Status: 1,
          QualityType: selectedQualityType,
          SubQualityType: selectedSubQualityType
        }
      }

      this.setState({
        selectedSpareParts: selectedSpareParts,
        spareParts: next.selectedSpareParts,
        ...extra
      }, () => {
        if (next.view !== this.state.view || next.isOpen) {
          this.changeView(next.view)
        }
      })
    }
  }

  getOrderFileSizes () {
    this.props.getOrderFileSizes(this.state.SelectedFilesIds).then((res) => {
      this.setState({ SelectedFileSizes: res.data })
    })
  }

  changeView (view, index) {
    if (index !== undefined) {
      this.setState({
        spareParts: [ this.state.spareParts[index] ],
        statusChange: { ...this.state.statusChange,
          Status: this.state.spareParts[index].Status,
          Quantity: this.state.spareParts[index].Count,
          QualityType: this.state.spareParts[index].QualityType,
          SubQualityType: this.state.spareParts[index].SubQualityType }
      })
    }
    this.setState({
      view: view
    })
    if (view === 'status') this.getOrderingSparePartSuppliers()
  }

  checkboxChange (e) {
    this.getSelectedFiles()
  }

  renderFileSizeError () {
    let { TotalSizeInMB, MaxEmailFileSizeInMB, HasExeededMaxEmailFileSize } = this.state.SelectedFileSizes

    let text = `${formatCurrency(TotalSizeInMB, 1)} / ${formatCurrency(MaxEmailFileSizeInMB, 1)} MB`

    if (!HasExeededMaxEmailFileSize) {
      return <Label>{text}</Label>
    }

    return (
      <Grid align='center' cols={['min-content', 'auto']}>
        <Icon size='s' icon={ElementIcons.Warning} />
        <span className='alert-message'>{text}</span>
      </Grid>
    )
  }

  renderImages () {
    let { images } = this.state
    // Render image
    const renderImage = (image, index) => {
      if (image.imageUrl !== undefined) {
        return (
          <div key={index}>
            <div className='divImg'>
              <div className='delete'><RemoveButton {...this.props} onClick={() => this.deleteImage(image, index)} size='s' /></div>
              <img className='img2' id={image.OrderFileID} src={image.imageUrl} />
            </div>
            <div className='divCheckbox'>
              <Check spacing={0} labelText={translation('1218')} id={image.OrderFileID} name='checkbox_image' checked disabled />
            </div>
          </div>
        )
      } else {
        return (
          <div key={index}>
            <div className='divImg'>
              <a href={image.imagePath} data-lightbox='gallery'>
                <img className='img3' id={image.OrderFileID} name='oldImages' src={image.thumbPath} />
              </a>
            </div>
            <div className='divCheckbox' >
              <Check spacing={0} labelText={translation('1218')} id={image.OrderFileID} name='checkbox_image' checked={this.state.SelectedFilesIds.includes(image.OrderFileID)} onChange={this.checkboxChange} />
            </div>
          </div>
        )
      }
    }

    // Confirm
    const onPortalClose = () => {
      this.setState({
        confirm: false
      })
    }
    const onConfirm = () => {
      if (this.state.imageToDeleteId !== 0) {
        var files = this.state.SelectedFilesIds.filter(x => {
          return x !== this.state.imageToDeleteId
        })
        this.setState({
          SelectedFilesIds: files,
          imageToDeleteId: 0
        }, this.getOrderFileSizes)
      }
      let images = [...this.state.images]
      images.splice(this.state.confirm, 1)
      this.setState({
        confirm: false,
        images: images
      })
    }

    return (
      <div>
        {this.renderFileSizeError()}
        <Gallery files={images} renderImage={renderImage} />
        {this.state.confirm !== false && (
          <Portal className='deleteModal' t={this.props.t} onPortalClose={onPortalClose}>
            <Confirm confirm={onConfirm} notConfirm={onPortalClose} />
          </Portal>
        )}
      </div>
    )
  }

  onDrop () {
    this.setState({ upload: { ...this.state.upload, errors: [] } })
  }

  onDropAccepted (files) {
    this.setState({ imageUploadsStarted: this.state.imageUploadsStarted + files.length })
    this.props.uploadMultipleFiles(files, this.props.orderId, undefined, undefined, undefined).then((fileResponse) => {
      let newImages = [ ...this.state.images ]
      const uploadedFiles = fileResponse.data
      uploadedFiles.map((val, index) => {
        if (val.IsImage) {
          newImages.push({
            imageUrl: val.RealFileURL,
            ImageSize: {
              Width: 0,
              Height: 0
            },
            OrderFileID: val.OrderFileID,
            circles: [],
            ImageType: 2,
            base64: files[index].imageUrl,
            rotation: 0
          })
        }
      })
      newImages.map((val) => {
        if (typeof val.ImageSize === 'undefined') {
          val.ImageSize = {
            Width: 0,
            Height: 0
          }
        }
      })
      this.setState({ images: newImages, imageUploadsCompleted: this.state.imageUploadsCompleted + files.length })
      this.getSelectedFiles()
    }).catch(() => {
      this.setState({ imageUploadsCompleted: this.state.imageUploadsCompleted + files.length })
    })
  }

  onDropRejected (files) {
    let newErrors = []
    files.map((val, index) => {
      newErrors.push(translation('1207') + ': ' + val.name + ' ' + translation('13405') + '.')
    })
    this.setState({ upload: { ...this.state.upload, errors: newErrors } })
  }

  deleteImage (image, index) {
    this.setState({
      confirm: index,
      imageToDeleteId: image.OrderFileID
    })
  }

  getSelectedFiles () {
    let orderFileIds = []
    let inp = document.getElementsByTagName('input')
    for (let i = 0; i < inp.length; i++) {
      if (inp[i].name === 'checkbox_image' && inp[i].checked === true) {
        orderFileIds.push(Number(inp[i].id))
      }
    }
    this.setState({
      SelectedFilesIds: orderFileIds
    }, this.getOrderFileSizes)
  }

  getSpareParts (sparePartNumbers) {
    let relevantParts = this.props.spareParts.filter(sp => {
      return sparePartNumbers.includes(sp.OriginalSparePartNumber)
    })

    this.setState({
      spareParts: relevantParts
    })
  }

  getOrderingSparePartSuppliers () {
    let hasUrgent = this.state.selectedSpareParts.findIndex(x => x.UrgentDelivery) !== -1
    this.props.getOrderingSparePartSuppliers(this.props.orderId, hasUrgent ? 2 : 1).then(res => {
      this.setState({
        suppliers: res.data
      })
    })
  }

  closeSlidePanel (preventResetingView = false) {
    this.setState({ // Dafault state
      view: preventResetingView ? this.state.view : '',
      spareParts: [],
      add: {
        sparepart: {
          OrderId: 0,
          SparePartNumber: '',
          Quantity: 1
        }
      },
      statusChange: {
        Quantity: 1,
        Status: 1,
        Comment: '',
        SupplierId: null,
        Pickup: null
      },
      partNumberChange: {
        Quantity: 1,
        SparePartNumberAlias: '',
        useAlternativePartNumber: 0
      }
    })
    this.props.onDone()
    this.props.closeSlidePanel(this.props.slidePanelId)
  }

  isMultipleSpareParts () {
    return this.state.spareParts.length > 1
  }

  isDracarMatch (status) {
    switch (status) {
      case 2:
      case 4:
      case 5:
      case 1001:
      case 2002:
        return true
      default:
        return false
    }
  }

  usesDracar () {
    // We do not check if invoicing to Dracar is active, just that they are allowed and have it selected.
    return this.props.auth.permissions.DracarUsable
  }

  usesDracarCreation () {
    return this.props.auth.permissions.UseDracarSparePartCreation
  }

  renderAddSparepart () {
    const createSparePart = () => {
      let data = this.state.add.sparepart
      data.OrderId = this.props.orderId
      data.Filter = this.props.sparePartsFilter
      this.props.createSparePart(data).then(() => {
        // this.changeView('status')
        this.getSpareParts([data.SparePartNumber])
        this.closeSlidePanel()
        // this.props.onDone('add', data.SparePartNumber)
        this.props.onDone()
      })
    }

    const onChange = (e) => {
      let target = e.target
      if (!target) target = e

      this.setState({
        add: {
          ...this.state.add,
          sparepart: {
            ...this.state.add.sparepart,
            [target.name]: target.value
          }
        }
      })
    }

    let sparepart = this.state.add.sparepart
    let isDisabled = sparepart.SparePartNumber.length === 0 || (this.usesDracar() && this.usesDracarCreation())
    return ([
      <div className='top' key={0}>
        <h1 className='title'>{translation(16445)}</h1>
      </div>,
      <div className='content' key={1}>
        <Text labelText={translation(16445)} placeholder={translation(16446)} name='SparePartNumber' value={sparepart.SparePartNumber} onChange={onChange} />
        <CountSpecifier disabled={isDisabled} value={sparepart.Quantity} name='Quantity' onChange={onChange} />
        <Divider />
      </div>,
      <BottomBar disabled={isDisabled} actionLabelText={translation(1208)} cancelLabelText={translation(16444)} onCancelClick={() => this.closeSlidePanel(true)} onActionClick={createSparePart} key={2} />
    ])
  }

  renderStatusChange (multiType) {
    let { spareParts, statusChange, suppliers } = this.state
    let showStatus = (!multiType || multiType === 'status' || !this.isMultipleSpareParts())
    let showQuality = (!multiType || multiType === 'quality' || !this.isMultipleSpareParts())
    const onChange = (e) => {
      let { name, value, checked, type } = e.target

      let newValue = value
      let extra = {}

      const setExtraForSupplier = supplier => {
        extra.SupplierId = supplier.Id
        extra.Pickup = supplier.PickupSelf // Set default value for pickup
        extra.Discount = supplier.Discount
        extra.DeliveryDate = supplier.DeliveryDate
      }

      if (type === 'checkbox') {
        newValue = checked
      }

      if (name === 'Status' || name === 'QualityType' || name === 'SubQualityType') {
        newValue = Number(value)

        if (newValue === 8 && Array.isArray(suppliers) && suppliers.length === 1) {
          // If only one supplier, select
          setExtraForSupplier(suppliers[0])
        }
      }
      if (name === 'QualityType' && newValue === 2) {
        statusChange.SubQualityType = 1
      }

      if (name === 'SupplierId') {
        newValue = Number(value)

        const supplier = suppliers.find(x => x.Id === newValue)
        setExtraForSupplier(supplier)
      }

      this.setState({
        statusChange: {
          ...statusChange,
          ...extra,
          [name]: newValue
        }
      })
    }

    let totalCount = spareParts.reduce((total, part) => {
      return total + part.Count
    }, 0)

    const renderContent = () => {
      let hasSuppliers = Array.isArray(suppliers) && suppliers.length > 0

      const renderSupplierRadio = (supplier, key) => {
        const name = 'SupplierId'
        const value = supplier.Id
        const checked = statusChange.SupplierId === supplier.Id

        const onClick = () => {
          const supplier = suppliers.find(x => x.Id === value)

          let date = ''
          let time = ''
          if (checked && statusChange.DeliveryDate) {
            date = moment(statusChange.DeliveryDate)
          }
          if ((!moment.isMoment(date) || !date.isValid()) && supplier.DeliveryDate) {
            date = moment(supplier.DeliveryDate)
          }
          if (moment.isMoment(date) && date.isValid()) {
            time = date.format('HH:mm')
          }

          this.setState({
            supplierDeliveryChange: {
              supplierId: value,
              deliveryDate: date,
              deliveryTime: time
            }
          })

          this.changeView('supplierDelivery')
        }

        const renderSupplierInfo = () => {
          const date = checked ? statusChange.DeliveryDate : supplier.DeliveryDate
          return (
            <Grid cols={[ 'min-content', 1 ]} align='center' onClick={onClick} >
              {supplier.Discount ? <span className='suppliers__discount'>-{supplier.Discount} %</span> : <div />}
              <span className='suppliers__delivery'>{date && getRelativeDateTime(date)}</span>
            </Grid>
          )
        }

        return (
          <div className='suppliers__item' key={'suppliersItem_' + key}>
            <Grid cols={[ 1, 'min-content' ]} align='center'>
              <Radio name={name} value={value} checked={checked} onChange={onChange} labelText={supplier.Name} />
              <i className='fa fa-chevron-right' onClick={onClick} />
            </Grid>
            {renderSupplierInfo()}
          </div>
        )
      }

      const renderPreviousComment = (item, index) => {
        return (
          <div key={index}>
            <Label>{item.Note}</Label>
            <h4>{`${item.NoteUserName} - ${renderFullDate(item.NoteDate)}`}</h4>
            <Divider />
          </div>
        )
      }

      return (
        <div className='content status' key='content'>
          {totalCount > 1 && !this.isMultipleSpareParts() && [<LabelWrapper labelText={translation(16447)} key={0}>
            <CountSpecifier total={totalCount} name='Quantity' value={statusChange.Quantity} onChange={onChange} />
          </LabelWrapper>,
            <Divider size={3} key={1} />
          ]}

          {(showQuality) && (<LabelWrapper labelText={translation(17849)}>
            <Radio name='QualityType' value={0} checked={statusChange.QualityType === 0} onChange={onChange} labelText={translation(17850)} />
            <Radio name='QualityType' value={1} checked={statusChange.QualityType === 1} onChange={onChange} labelText={translation(17851)} />
            <Radio name='QualityType' value={2} checked={statusChange.QualityType === 2} onChange={onChange} labelText={translation(76)} />
            {statusChange.QualityType === 2 && (
              <div className='subquality'>
                <Radio name='SubQualityType' value={1} checked={statusChange.SubQualityType === 1} onChange={onChange} labelText={translation(17852)} />
                <Radio name='SubQualityType' value={2} checked={statusChange.SubQualityType === 2} onChange={onChange} labelText={translation(17853)} />
                <Radio name='SubQualityType' value={3} checked={statusChange.SubQualityType === 3} onChange={onChange} labelText={translation(17854)} />
              </div>
            )}
          </LabelWrapper>)}
          {(showStatus) && (<LabelWrapper labelText={translation(16448)}>
            <Radio name='Status' value={1} checked={statusChange.Status === 1} onChange={onChange} labelText={translation(15392)} />
            <Radio name='Status' value={2} checked={statusChange.Status === 2} onChange={onChange} labelText={translation(16449)} />
            {!this.usesDracar() ? <Radio name='Status' value={4} checked={statusChange.Status === 4} onChange={onChange} labelText={translation(14799)} /> : null}
            <Radio name='Status' value={8} checked={statusChange.Status === 8} onChange={onChange} labelText={translation(16457) + '...'} disabled={!hasSuppliers} />
            <div className='suppliers'>
              {!hasSuppliers && <label>{translation(16460)}</label>}
              {hasSuppliers && statusChange.Status === 8 && ([
                suppliers.map(renderSupplierRadio),
                <Divider key='divider_0' />,
                <Check key='check_1' name='Pickup' checked={statusChange.Pickup} onChange={onChange} labelText={<Inline spacing={0}>{translation(16458)}<Icon icon={SparePartModuleIcons.Pickup} /></Inline>} />
              ])}
            </div>
          </LabelWrapper>)}

          <Divider size={3} />

          <Textarea name='Comment' value={statusChange.Comment} onChange={onChange} labelText={translation(149)} />
          <Check key={1} name='AddCommentToOrderEmail' checked={statusChange.AddCommentToOrderEmail} onChange={onChange} labelText={<Inline spacing={0}>{translation(18072)}</Inline>} />
          <div>
            <Dropzone
              onDrop={this.onDrop}
              onDropAccepted={this.onDropAccepted}
              onDropRejected={this.onDropRejected}>
              <p>{translation('13397')}</p>
            </Dropzone>
          </div>
          {this.renderImages()}
          {this.props.previousComments.length > 0 && (<div className='previous-comments'>
            <LabelWrapper labelText={translation(16459)}>
              {this.props.previousComments.map(renderPreviousComment)}
            </LabelWrapper>
          </div>)}
        </div>
      )
    }

    const submitSpareParts = () => {
      let sparePartsBody = {
        OrderId: this.props.orderId,
        SpareParts: this.state.spareParts,
        ...statusChange,
        Quantity: !this.isMultipleSpareParts() ? statusChange.Quantity : null,
        Filter: this.props.sparePartsFilter,
        SelectedFilesIds: this.state.SelectedFilesIds
      }

      this.setState({
        isLoading: true
      })

      this.props.updateSparePartsOrdering(sparePartsBody).then((res) => {
        if (res.data.Errors !== null && res.data.Errors.length > 0) {
          res.data.Errors.map(x => window.toastr.info(translation(x.DictionaryKey)))
        } else if (sparePartsBody.Status === 8) { // Status is ordering
          // window.toastr.success(translation('16462'), translation('13424'))
        }

        this.setState({
          isLoading: false
        }, this.closeSlidePanel)
      }, () => {
        this.setState({
          isLoading: false
        })
        window.toastr.error(translation('960'), translation('216'))
      })
    }

    let titleText = translation(13052)
    const statusHeader = []

    if (spareParts.length === 1) {
      if (this.usesDracar() && this.isDracarMatch(spareParts[0].DracarStatus)) {
        statusHeader.push(<h3 key='header_0' className='sub-title'>{`${totalCount} x ${spareParts[0].SparePartNumberAlias || spareParts[0].OriginalSparePartNumber}`}</h3>)
      } else {
        statusHeader.push(<h3 key='header_1' className='clickable sub-title' onClick={() => this.changeView('partNumber')}>{`${totalCount} x ${spareParts[0].SparePartNumberAlias || spareParts[0].OriginalSparePartNumber}`}</h3>)
        statusHeader.push(<i key='header_2' className='fa fa-chevron-right clickable sub-title-right' onClick={() => this.changeView('partNumber')} />)
      }
    } else {
      let hasUrgent = this.state.selectedSpareParts.findIndex(x => x.UrgentDelivery) !== -1
      let header = (
        <div className='sub-title' key='header_3'>
          <h3>{translation(16451)} #</h3>
          {hasUrgent && <p className='alert-urgent'>{translation(17905)}</p>}
        </div>)
      statusHeader.push(header)
    }

    return ([
      <div className='top' key='top'>
        <h1 className='title'>{titleText}</h1>
        {statusHeader}
      </div>,
      renderContent(),
      <BottomBar disabled={this.state.isLoading || this.state.SelectedFileSizes.HasExeededMaxEmailFileSize} actionLabelText={translation(16455)} cancelLabelText={translation(16444)} onCancelClick={this.closeSlidePanel} onActionClick={submitSpareParts} key={2} />
    ])
  }

  renderListDetail () {
    let { spareParts } = this.state

    let totalCount = spareParts.reduce((total, part) => {
      return total + part.Count
    }, 0)

    const renderStatus = (item, index) => {
      let icon = SparePartModuleIcons.OK
      let isOrdered = item.Status === 8
      if (item.Status === 1) icon = SparePartModuleIcons.Warning
      let status
      switch (item.Status) {
        case 2:
          status = translation(16449)
          break
        case 4:
          status = translation(14799)
          break
        case 8:
          status = translation(16457) + '...'
          break
        case 1:
        default:
          status = translation(15392)
          break
      }

      let supplier = item.Suppliers[0]

      return ([
        <Grid cols={'auto min-content'}>
          <LabelWrapper labelText={`${translation(13052)} - ${status}`} key={index}>
            <Grid cols='min-content auto'>
              <Icon icon={icon} injectSvg />
              <Grid cols='auto'>
                <Label>{`${item.Count} x ${item.Status === 8 ? supplier.Name : status}`}</Label>
                <Label>{`${item.Count} x ${isOrdered ? item.Suppliers[0].Name : status}`}</Label>

                {supplier && (supplier.Discount > 0 || supplier.DeliveryDate) && (
                  <div className='suppliers'>
                    <Grid cols={[ 'max-content', 'min-content' ]} align='center'>
                      <span className='suppliers__delivery'>{supplier.DeliveryDate && getRelativeDateTime(supplier.DeliveryDate)}</span>
                      {supplier.Discount ? <span className='suppliers__discount'>-{supplier.Discount} %</span> : <div />}
                    </Grid>
                  </div>
                )}

                {item.RequiresPaint && <h4>{translation(16450)}</h4>}
                {item.Pickup && <h4>{translation(16458)}</h4>}
              </Grid>
            </Grid>
          </LabelWrapper>
          {!isOrdered ? <i className='fa fa-chevron-right clickable sub-title-right' onClick={() => this.changeView('status', index)} /> : <div />}
        </Grid>,
        <Divider size={3} key={index + 1} />
      ])
    }

    const sparePart = spareParts[0] || {}
    const partCount = `${totalCount} x ${sparePart.SparePartNumberAlias || sparePart.OriginalSparePartNumber}`
    let titleText = translation(13052)
    let allowSparePartNumberChange = true
    let clickableSubtitle = <h3 className='sub-title clickable' onClick={() => this.changeView('partNumber')}>{partCount}</h3>

    if (this.usesDracar()) {
      const foundMatched = spareParts.find(sp => this.isDracarMatch(sp.DracarStatus))

      if (foundMatched) {
        allowSparePartNumberChange = false
        clickableSubtitle = <h3 className='sub-title'>{partCount}</h3>
      }
    }

    return ([
      <div className='top' key={0}>
        <h1 className='title'>{titleText}</h1>
        {clickableSubtitle}
        {allowSparePartNumberChange ? <i className='fa fa-chevron-right clickable sub-title-right' onClick={() => this.changeView('partNumber')} /> : <div />}
      </div>,
      <div className='content status-list' key={1}>
        {spareParts.map(renderStatus)}
      </div>,
      <BottomBar cancelLabelText={translation(235)} onCancelClick={this.closeSlidePanel} key={2} />
    ])
  }

  renderSparepartNumberChange () {
    let { spareParts, partNumberChange } = this.state
    let sparepart = spareParts[0]
    let count = sparepart.Count

    if (this.usesDracar()) {
      if (spareParts.length > 1) {
        sparepart = spareParts.find(sp => sp.Status === 1)

        if (!sparepart) {
          sparepart = spareParts.find(sp => sp.Status === 2)
        }

        count = sparepart.Count
      } else {
        count = sparepart.Count - sparepart.Handled
      }
    }

    const onChange = (e) => {
      let target = e.target
      if (!target) target = e

      let extra = {}
      let newValue = target.value
      let name = target.name

      if (name === 'useAlternativePartNumber') newValue = Number(newValue)
      if ((name === 'SparePartNumberAlias' && newValue.length > 0) || (name === 'useAlternativePartNumber' && newValue === 1)) extra.useAlternativePartNumber = 1
      else if ((name === 'SparePartNumberAlias' && (!newValue || newValue.length === 0)) || (name === 'useAlternativePartNumber' && newValue === 0)) extra.useAlternativePartNumber = 0

      this.setState({
        partNumberChange: {
          ...partNumberChange,
          ...extra,
          [name]: newValue
        }
      })
    }

    const onDone = () => {
      this.changeView(this.props.view)
    }

    const submitSpareParts = () => {
      if (partNumberChange.useAlternativePartNumber === 0) { // If not use alias go back to previous view
        onDone()
        return
      }

      let data = {
        OrderId: this.props.orderId,
        SpareParts: spareParts,
        Quantity: partNumberChange.Quantity,
        SparePartNumberAlias: partNumberChange.SparePartNumberAlias,
        Filter: this.props.sparePartsFilter,
        SelectedFilesIds: this.state.SelectedFilesIds
      }

      this.props.updateSparePartsOrdering(data).then((res) => {
        if (res.data.Errors.length > 0) {
          res.data.Errors.map(x => window.toastr.info(translation(x.DictionaryKey)))
        }

        this.closeSlidePanel()
      }, () => {
        window.toastr.error(translation('960'), translation('216'))
      })
    }

    let totalCount = count // - sparepart.Handled
    let hasValidPartNumber = partNumberChange.SparePartNumberAlias.length > 0
    let useAlternative = partNumberChange.useAlternativePartNumber === 1
    let allowAlternatePartNumber = true
    if (this.usesDracar()) {
      allowAlternatePartNumber = count > 0
    }

    const renderOriginalSparePartNUmberInfo = () => {
      return ([
        <Label key={0} size='t'>{sparepart.SparePartNumberAlias || sparepart.OriginalSparePartNumber}</Label>,
        <Label key={1} size='t'>{sparepart.Description}</Label>
      ])
    }
    return ([
      <div className='top' key={0}>
        <Icon className='clickable title-left' icon={SparePartModuleIcons.Back} onClick={onDone} />
        <h1 className='clickable title' onClick={onDone}>{translation(16463)}</h1>
      </div>,
      <div className='content partnumber' key={1}>
        <LabelWrapper labelText={sparepart.OrderSparePartId ? translation(16464) : translation(16465)}>
          <Radio name='useAlternativePartNumber' value={0} checked={partNumberChange.useAlternativePartNumber === 0} onChange={onChange} labelText={renderOriginalSparePartNUmberInfo()} />
        </LabelWrapper>
        <OrangeDivider labelText={16467} size={2} />
        <LabelWrapper labelText={translation(16466)}>
          <Inline>
            <Radio simple name='useAlternativePartNumber' value={1} checked={useAlternative} onChange={onChange} disabled={!allowAlternatePartNumber} />
            <Text placeholder={translation(16446)} name='SparePartNumberAlias' value={partNumberChange.SparePartNumberAlias} onChange={onChange} disabled={!allowAlternatePartNumber} />
          </Inline>
        </LabelWrapper>

        {useAlternative && totalCount > 1 && <LabelWrapper labelText={translation(16441)}>
          <CountSpecifier disabled={!hasValidPartNumber} value={partNumberChange.Quantity} total={totalCount} name='Quantity' onChange={onChange} />
        </LabelWrapper>}
        <Divider />
      </div>,
      <BottomBar disabled={useAlternative && !hasValidPartNumber && allowAlternatePartNumber} actionLabelText={translation(791)} cancelLabelText={translation(1155)} onCancelClick={onDone} onActionClick={submitSpareParts} key={2} />
    ])
  }

  renderSupplierDelivery () {
    const { spareParts, suppliers, supplierDeliveryChange: { supplierId, deliveryDate, deliveryTime } } = this.state
    const sparePart = spareParts[0] || {}

    const onDone = () => {
      this.changeView(this.props.view)
    }

    const onDateChange = (date) => {
      this.setState({
        supplierDeliveryChange: {
          ...this.state.supplierDeliveryChange,
          deliveryDate: date
        }
      })
    }

    const onChange = (e) => {
      const { value } = e.target

      this.setState({
        supplierDeliveryChange: {
          ...this.state.supplierDeliveryChange,
          deliveryTime: value
        }
      })
    }

    const onSaveChanges = () => {
      const newDate = moment.isMoment(deliveryDate) ? deliveryDate.clone() : ''

      const hourMin = deliveryTime.split(':')
      newDate.set({ hour: hourMin[0], minute: hourMin[1] || 0, second: 0, millisecond: 0 })

      const supplier = suppliers.find(x => x.Id === supplierId)

      this.setState({
        statusChange: {
          ...this.state.statusChange,
          SupplierId: supplierId,
          Pickup: supplier.PickupSelf,
          Discount: supplier.Discount,
          DeliveryDate: newDate.format('YYYY-MM-DD[T]HH:mm:ss')
        }
      }, () => onDone())
    }

    const inputProps = {
      name: 'date'
    }

    return [
      <div className='top' key={0}>
        <Icon className='clickable title-left' icon={SparePartModuleIcons.Back} onClick={onDone} />
        <h1 className='clickable title' onClick={onDone}>{translation('15370')}</h1>
        <h3 className='sub-title clickable'>{`${sparePart.SparePartNumberAlias || sparePart.OriginalSparePartNumber}`}</h3>
      </div>,
      <div className='content supplierDelivery' key={1}>
        <LabelWrapper labelText={translation('16520')}>
          <Grid cols={[2, 1]}>
            <DateTime
              inputProps={inputProps}
              timeFormat={false}
              closeOnSelect
              value={deliveryDate}
              onChange={onDateChange}
            />
            <Time name='time' value={deliveryTime} onChange={onChange} />
          </Grid>
        </LabelWrapper>
      </div>,
      <BottomBar actionLabelText={translation('14732')} onActionClick={onSaveChanges} key={2} />
    ]
  }

  renderSlidePanelContent () {
    switch (this.state.view) {
      case 'add':
        return this.renderAddSparepart()
      case 'status':
        return this.renderStatusChange('status')
      case 'multiQuality':
        return this.renderStatusChange('quality')
      case 'listDetail':
        return this.renderListDetail()
      case 'partNumber':
        return this.renderSparepartNumberChange()
      case 'supplierDelivery':
        return this.renderSupplierDelivery()
      default:
        return null
    }
  }

  render () {
    return (
      <SlidePanel slidePanelId={this.props.slidePanelId} isLoading={this.state.isLoading}>
        {this.renderSlidePanelContent()}
      </SlidePanel>
    )
  }
}

OrderingSlidePanel.propTypes = {
  orderId: React.PropTypes.number.isRequired,
  slidePanelId: React.PropTypes.string.isRequired,
  view: React.PropTypes.string.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    spareParts: state.spareParts.sparePartsOrdering,
    sparePartsFilter: state.spareParts.sparePartsFilterOrdering,
    previousComments: state.spareParts.sparePartsCommentsOrdering,
    headerInfo: state.common.headerInfo
  }
}

export default connect(mapStateToProps, {
  createSparePart,
  closeSlidePanel,
  isSlidePanelOpen,
  updateSparePartsOrdering,
  getOrderingSparePartSuppliers,
  getOrderingSparePartDetails,
  uploadMultipleFiles,
  getOrderFiles,
  getOrderFileSizes
})(OrderingSlidePanel)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/spareParts/orderingSlidePanel/index.js